import React from 'react';

const IconCloseSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
      <path
        d="M11.6 13L6.65 8.04 1.7 13a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.38l4.95-4.95L.28 1.7C-.112 1.318-.112.682.28.3S1.308-.102 1.7.3l4.95 4.95L11.6.3a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.39L8.06 6.63 13 11.6a1 1 0 0 1-.71 1.706 1 1 0 0 1-.71-.296z"
        fill="#010101"
      />
    </svg>
  );
};

export default IconCloseSvg;
